export default __webpack_public_path__ + "static/media/bg-polisport-usa.1f140ae0.jpg";